<script setup>

import { Link }  from '@inertiajs/vue3';

import {scrollTop} from "@/utility";

// import Swiper core and required modules
import { Navigation, Pagination, A11y } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/vue';

// Swiper modules
const modules = [Navigation, Pagination, A11y];

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/zoom';

var swiperInstance;

const onSwiper = (swiper) => {
	swiperInstance = swiper;
};

const slideTo = (index) => {
	swiperInstance.slideTo(index);
}

</script>

<template>

	<swiper
		class="related-products-gallery"
		:modules="modules"
		:slides-per-view="itemsToShow"
		:space-between="50"
		:pagination="{ clickable: true }"
		@swiper="onSwiper">

		<swiper-slide v-for="(item, itemKey) in items">
			<Link :href="item.translation.slug" :preserveScroll="false" :onFinish="scrollTop">
				<div class="product-image-wrapper">
					<img class="product_image" :src="item.images.length ? ('/storage/product_image' + item.images[0].name) : ''" alt="" max-width="100">
				</div>
				<div class="price-wrapper" v-if="item.price.price_new">
					<span class="price">{{ item.price.price_new.toFixed(2) }} {{ $page.props.store.currency_symbol || $page.props.store.currency_code }}</span>
					<span class="old-price">
						<template v-if="item.price.price_old">
							{{ item.price.price_old.toFixed(2) }} {{ $page.props.store.currency_symbol || $page.props.store.currency_code }}
						</template>
					</span>
				</div>
			</Link>

		</swiper-slide>

	</swiper>

</template>

<script>

export default {
	name: "RelatedProductsGallery",
	components: {},
	props: ['items'],
	data(){
		return {
			itemsToShow : 1,
		}
	},
	mounted(){
		var vm = this;
		vm.calculateItemsToShow();
		window.removeEventListener('resize', () => {}, false)
		window.addEventListener('resize', vm.calculateItemsToShow);
	},
	methods : {

		calculateItemsToShow(){

			var vm = this;
			let windowWidth = window.innerWidth;

			let thresholds = [
				{
					min : 0,
					max : 450,
					itemsToShow : 2
				},
				{
					min : 451,
					max : 767,
					itemsToShow : 3
				},
				{
					min : 768,
					max : 991,
					itemsToShow : 3
				},
				{
					min : 992,
					max : 1199,
					itemsToShow : 3
				},
				{
					min : 1200,
					max : 1399,
					itemsToShow : 4
				},
				{
					min : 1400,
					max : 10000,
					itemsToShow : 5
				},
			];

			thresholds.map(threshold => {
				if(windowWidth >= threshold.min && windowWidth <= threshold.max)
					vm.itemsToShow = threshold.itemsToShow > vm.items.length ? vm.items.length : threshold.itemsToShow;
			});

		}

	}
}
</script>